import { EventData, SET_EVENTS, SetEventsAction } from './types';

const publishEvent = (data: EventData): SetEventsAction => ({
    type: SET_EVENTS,
    payload: data,
});

export default publishEvent;
